import React from "react";
import { Box, VStack } from "@chakra-ui/react";

import { ChakraText } from "components/ChakraText";
import { Modal } from "components/Modal";

import { LoginForm } from "modules/authentication/presentation/LoginForm";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  openRemindPasswordModal: () => void;
}

const LoginModal = ({ isOpen, onClose, openRemindPasswordModal }: IProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalHeader={<ChakraText>Logowanie</ChakraText>}
    >
      <VStack spacing={4}>
        <Box w="100%">
          <LoginForm
            onCloseModal={onClose}
            openRemindPasswordModal={openRemindPasswordModal}
          />
        </Box>
      </VStack>
    </Modal>
  );
};

export { LoginModal };
